package com.arena_web.ui.localization

object AppStringsIT : AppStrings {

    // language selector
    override val headerProfileLanguage = "Lingua"
    override val headerProfileLanguageRecommended = "Consigliato"

    // common
    override val commonSeeAll = "Vedi tutto"
    override val commonNo = "No"
    override val commonYes = "Sì"
    override val commonConfirm = "Conferma"
    override val commonSend = "Invia"
    override val commonError = "Errore"
    override val commonOk = "OK"

    // chat
    override val chatMenuUnmute = "Riattiva notifiche"
    override val chatMenuMute = "Silenzia"
    override val chatMenuInviteMembers = "Invita membri"
    override val chatMenuLeaveGroup = "Esci dal gruppo"
    override val chatMenuDeleteChat = "Elimina chat"
    override fun chatRemoveMemberTitle(name: String) = "Rimuovere $name?"
    override fun chatRemoveMemberWarning(name: String) = "Rimuovere $name dal gruppo? Questa azione non può essere annullata."
    override val chatRemoveMemberAction = "Rimuovi"
    override val chatDefaultName = "Chat"
    override fun chatTypingOne(name: String) = "$name sta scrivendo..."
    override fun chatTypingMany(count: Int) = "$count persone stanno scrivendo..."
    override fun chatMembersCount(count: Int) = "$count membri"
    override fun chatMembersCountOnline(count: Int, online: Int) = "$count membri, $online online"
    override val chatOnline = "Online"
    override val chatOffline = "Offline"
    override val chatEditCommunityTitle = "Modifica community"
    override val chatCommunityNameLabel = "Nome della community"
    override val chatCommunityNamePlaceholder = "Inserisci il nome della community..."
    override val chatSaving = "Salvataggio..."
    override val chatMessageInputPlaceholder = "Scrivi un messaggio..."
    override val chatInviteMembersTitle = "Invita membri"
    override val chatSearchFriendsPlaceholder = "Cerca amici..."
    override val chatNoFriendsToInvite = "Nessun amico da invitare"
    override val chatNoResults = "Nessun risultato"
    override val chatInviting = "Invito in corso..."
    override val chatInvite = "Invita"
    override fun chatInviteCount(count: Int) = "Invita ($count)"
    override val chatPanelTitle = "Chat Arena"
    override val chatSearchPlaceholder = "Cerca chat"
    override val chatFilterAll = "Tutte"
    override val chatFilterDirect = "Dirette"
    override val chatFilterCommunity = "Community"
    override val chatNoChatsFound = "Nessuna chat trovata"
    override val chatNoConversationsYet = "Ancora nessuna conversazione"
    override val chatNewChatTitle = "Nuova chat"
    override val chatTabDirectMessage = "Messaggio diretto"
    override val chatTabCommunity = "Community"
    override val chatSearchPeoplePlaceholder = "Cerca tra le persone che segui..."
    override val chatNotFollowingAnyone = "Non segui ancora nessuno"
    override val chatCreating = "Creazione..."
    override val chatCreateCommunity = "Crea community"
    override val chatSelectConversation = "Seleziona una conversazione"
    override fun chatReplyTo(name: String) = "Rispondi a $name"
    override val chatUnknownSender = "Sconosciuto"
    override val chatUploading = "Caricamento..."
    override val chatEditingMessage = "Modifica messaggio"
    override val chatSearchInChatPlaceholder = "Cerca nella chat..."
    override fun chatSearchResultsFound(count: Int) = "$count trovati"
    override val chatGroupInfoTitle = "Info gruppo"
    override val chatUserInfoTitle = "Info utente"
    override val chatDeleteChatAction = "Elimina chat"
    override val chatDeleteGroupAction = "Elimina gruppo"
    override val chatLeaveGroupAction = "Esci dal gruppo"
    override val chatLastSeenRecently = "ultimo accesso di recente"
    override val chatNotificationsLabel = "Notifiche"
    override val chatTabMembers = "Membri"
    override val chatTabMedia = "Media"
    override val chatTabFiles = "File"
    override val chatTabLinks = "Link"
    override val chatLoading = "Caricamento..."
    override val chatNoMediaYet = "Ancora nessun media"
    override val chatNoFilesYet = "Ancora nessun file"
    override val chatUnknownFile = "File sconosciuto"
    override val chatNoLinksYet = "Ancora nessun link"
    override val chatNoMembers = "Nessun membro"
    override val chatRoleOwner = "Proprietario"
    override val chatRoleAdmin = "Admin"
    override val chatEdited = "modificato"
    override val chatFileFallback = "File"
    override val chatMenuReply = "Rispondi"
    override val chatMenuPin = "Fissa"
    override val chatEmptyTitle = "Ancora nessuna chat"
    override val chatEmptySubtitle = "Inizia una conversazione per vedere qui i tuoi messaggi."
    override val chatUnnamed = "Senza nome"
    override val chatNoMessagesYet = "Ancora nessun messaggio"
    override val chatRoomEmptyTitle = "Ancora nessun messaggio"
    override val chatRoomEmptySubtitle = "Saluta per iniziare la conversazione."
    override fun chatMembersHeader(count: Int) = "Membri ($count)"
    override val chatNoMediaSharedYet = "Ancora nessun media condiviso"
    override val chatNoFilesSharedYet = "Ancora nessun file condiviso"
    override val chatNoLinksSharedYet = "Ancora nessun link condiviso"

    // widget
    override val widgetDismiss = "Chiudi"
    override val widgetSomethingWentWrong = "Qualcosa è andato storto"
    override val widgetTryAgain = "Riprova"
    override val widgetCookieTitle = "Usiamo i cookie"
    override val widgetCookieMessage = "Questo sito utilizza i cookie per garantirti la migliore esperienza."
    override val widgetCookieDecline = "Rifiuta"
    override val widgetCookieAccept = "Accetta"
    override val widgetAddInterval = "Aggiungi intervallo"
    override val widgetSendMessage = "Invia messaggio"
    override val widgetPrevious = "Precedente"
    override val widgetStatusVip = "VIP"
    override val widgetStatusActive = "Attivo"
    override val widgetStatusDebtor = "Debitore"
    override val widgetStatusInactive = "Inattivo"
    override val widgetUnpaid = "non pagato"
    override val widgetStatusInProgress = "In corso"
    override val widgetStatusUpcoming = "In arrivo"
    override val widgetStatusPending = "In attesa"
    override val widgetStatusCompleted = "Completato"
    override fun widgetFieldLabel(number: String) = "Campo $number"
    override val widgetYearly = "Annuale"
    override val widgetAllFields = "Tutti i campi"
    override val widgetPreviousMonth = "Mese precedente"
    override val widgetNextMonth = "Mese successivo"
    override val widgetSortAscending = "Ordine crescente"
    override val widgetSortDescending = "Ordine decrescente"
    override val widgetChecked = "Selezionato"

    // form
    override val formSelectPlaceholder = "Seleziona..."

    // common
    override val commonCancel = "Annulla"
    override val commonErrorConnection = "Problema di connessione. Controlla la tua connessione e riprova."
    override val commonSave = "Salva"
    override val commonDelete = "Elimina"
    override val commonEdit = "Modifica"
    override val commonNext = "Avanti"
    override val commonRetry = "Riprova"
    override val commonSearch = "Cerca"

    // event
    override val eventMatchEndedTitle = "LA PARTITA È FINITA"
    override val eventMatchEndedSubtitle = "Valuta i giocatori per aggiornare le loro classifiche personali."
    override val eventTabMatchInfo = "Info partita"
    override val eventTabLineups = "Formazioni"
    override val eventTabMedia = "Media"
    override val eventCreateTeam = "Crea squadra"
    override val eventCancelEventQuestion = "Annullare l'evento?"
    override val eventDeleteEventQuestion = "Eliminare l'evento?"
    override fun eventWillBeCancelled(eventTitle: String) = "\"$eventTitle\" sarà contrassegnato come annullato."
    override fun eventWillBeDeleted(eventTitle: String) = "\"$eventTitle\" sarà eliminato definitivamente."
    override val eventCancelNoticeParticipants = "Gli altri partecipanti saranno avvisati. Chat e cronologia restano disponibili."
    override val eventDeleteNoticeMedia = "Anche l'immagine dell'evento e la chat saranno rimosse."
    override val eventKeepEvent = "Mantieni evento"
    override val eventCancelling = "Annullamento..."
    override val eventDeleting = "Eliminazione..."
    override val eventCancelEvent = "Annulla evento"
    override val eventMatchPerformanceTitle = "Prestazione della partita"
    override val eventProPlusLabel = "Pro⁺"
    override val eventStatLabel = "Stat"
    override val eventProPlusStatDescription = "Precisione dei tiri, riuscita dei passaggi e possesso palla nel dettaglio."
    override val eventLoadingMedia = "Caricamento media..."
    override val eventDeleteMediaQuestion = "Eliminare il media?"
    override val eventDeleteMediaMessage = "Questo file sarà rimosso dall'evento per tutti."
    override val eventNoMediaYet = "Ancora nessun media"
    override val eventNoMediaDescription = "Foto e video di questa partita appariranno qui."
    override val eventInviteTeamTitle = "Invita squadra"
    override val eventSearchTeamsLabel = "Cerca squadre"
    override val eventSearchTeamsPlaceholder = "Inserisci il nome della squadra..."
    override val eventSearching = "Ricerca..."
    override val eventNoTeamsFound = "Nessuna squadra trovata"
    override fun eventTeamRating(rating: String) = "Rating $rating"
    override fun eventTeamMembersCount(count: Int) = "$count membri"
    override val eventInviteStatusAccepted = "Accettato"
    override val eventInviteStatusDeclined = "Rifiutato"
    override val eventInviteStatusInvited = "Invitato"
    override val eventInvite = "Invita"
    override val eventStartEventQuestion = "Avviare l'evento?"
    override fun eventWillGoLive(eventTitle: String) = "\"$eventTitle\" andrà live."
    override val eventStartNotice = "Le iscrizioni si chiuderanno e la partita avrà inizio."
    override fun eventPendingRequestOne(count: Int) = "$count richiesta in sospeso"
    override fun eventPendingRequestsMany(count: Int) = "$count richieste in sospeso"
    override val eventPendingRequestsSubtitle = "Questi giocatori hanno chiesto di partecipare ma non sono ancora stati approvati."
    override fun eventPlayersWithoutTeamOne(count: Int) = "$count giocatore senza squadra"
    override fun eventPlayersWithoutTeamMany(count: Int) = "$count giocatori senza squadra"
    override val eventTeamlessSubtitle = "Sono confermati ma non assegnati a nessuna squadra."
    override val eventStarting = "Avvio..."
    override val eventStartAnyway = "Avvia comunque"
    override val eventMonthJanuary = "Gennaio"
    override val eventMonthFebruary = "Febbraio"
    override val eventMonthMarch = "Marzo"
    override val eventMonthApril = "Aprile"
    override val eventMonthMay = "Maggio"
    override val eventMonthJune = "Giugno"
    override val eventMonthJuly = "Luglio"
    override val eventMonthAugust = "Agosto"
    override val eventMonthSeptember = "Settembre"
    override val eventMonthOctober = "Ottobre"
    override val eventMonthNovember = "Novembre"
    override val eventMonthDecember = "Dicembre"
    override val eventVs = "vs"
    override val eventTeamsLabel = "squadre"
    override val eventPlayersLabel = "giocatori"
    override val eventProBadge = "PRO"
    override val eventProInfoSquadsTitle = "Crea e gestisci le rose."
    override val eventProInfoSquadsDesc = "Componi la tua rosa migliore e porta le squadre alla vittoria."
    override val eventProInfoStatsTitle = "Registra le statistiche della partita"
    override val eventProInfoStatsDesc = "Registra in tempo reale punteggi, gol, assist e prestazioni dei giocatori."
    override val eventProInfoResultsTitle = "Analizza i risultati della partita"
    override val eventProInfoResultsDesc = "Individua i migliori marcatori e i migliori giocatori della partita."
    override val eventCompletedBadge = "Concluso"
    override val eventLeadersEmptyWinGame = "Vinci un game per scalare la classifica."
    override val eventLeadersEmptyFirstScore = "Segna per primo e guida la classifica."
    override val eventLeadersEmptyTakeSet = "Conquista un set per prenderti la vetta."
    override val eventLeadersEmptyFirstAssist = "Sii il primo a servire l'assist decisivo."
    override fun eventTopStat(name: String) = "Top $name"
    override val eventPlayerFallback = "Giocatore"
    override val eventCreateTeamSubtitle = "Prepara la tua squadra per la partita"
    override val eventTeamNameLabel = "Nome della squadra"
    override val eventTeamNameRequired = "Il nome della squadra è obbligatorio"
    override val eventTeamColorLabel = "Colore della squadra"
    override val eventTeamColorSubtitle = "Scegli il colore della tua squadra"
    override val eventTeamNamePlaceholder = "Inserisci il nome della squadra..."
    override val eventChatTitle = "Chat"
    override val eventChatLive = "Live"
    override val eventChatPlayersLabel = "Giocatori"
    override val eventChatWaitingApproval = "In attesa di approvazione"
    override val eventChatConfirmingSpot = "Stiamo confermando il tuo posto"
    override val eventChatLocked = "La chat è bloccata"
    override val eventChatWaitingApprovalSubtitle = "Quando l'admin confermerà la tua richiesta potrai chattare con la squadra."
    override val eventChatConfirmingSpotSubtitle = "La tua richiesta di partecipazione è in elaborazione. La chat si sblocca appena entri."
    override val eventChatPrivateSubtitle = "Questo è un evento privato. Richiedi di partecipare e attendi l'approvazione dell'admin."
    override val eventChatLockedSubtitle = "Devi unirti a questa partita per vedere la conversazione e parlare con gli altri giocatori."
    override val eventJoinEvent = "Partecipa all'evento"
    override val eventChatNoMessages = "Ancora nessun messaggio"
    override val eventChatNoMessagesSubtitle = "Inizia la conversazione con la tua squadra."
    override val eventTeamSectionTitle = "Squadra"
    override val eventDeleteTeam = "Elimina squadra"
    override val eventViewProfile = "Vedi profilo"
    override val eventRemoveAdmin = "Rimuovi admin"
    override val eventMakeAdmin = "Rendi admin"
    override val eventRemoveFromTeam = "Rimuovi dalla squadra"
    override val eventRemoveFromEvent = "Rimuovi dall'evento"
    override fun eventFormatVs(format: Int) = "$format vs $format"
    override fun eventTeamsCount(count: Int) = "$count squadre"
    override fun eventPlayersOfMax(joined: Int, max: Int) = "$joined / $max giocatori"
    override fun eventPlayersCount(count: Int) = "$count giocatori"
    override val eventStatusLive = "Live"
    override val eventLeave = "Esci"
    override val eventStart = "Avvia"
    override val eventJoin = "Partecipa"
    override val eventStatusPending = "In attesa"
    override val eventStatusCanceled = "Annullato"
    override val eventPendingApprovalBadge = "In attesa di approvazione"
    override val eventRatePerformanceTitle = "Valuta la prestazione"
    override val eventRateVoteCounts = "Il tuo voto conta!"
    override val eventCommunityRating = "Valutazione della community"
    override val eventSubmitRating = "Invia valutazione"
    override val eventSubmitting = "Invio..."
    override val eventAddMediaTitle = "Aggiungi media"
    override val eventUploadMedia = "Carica media"
    override val eventDropMediaHere = "Trascina qui foto e video"
    override val eventMaxFileSize = "max 30 MB"
    override val eventSelectedLabel = "Selezionati"
    override val eventClearAll = "Cancella tutto"
    override val eventAddToTeam = "Aggiungi alla squadra"
    override val eventMakeSubstitution = "Fai una sostituzione"
    override val eventViewProfileSheet = "Vedi profilo"
    override fun eventSwapWith(name: String) = "Sostituisci $name con"
    override val eventEndMatch = "Termina partita"
    override val eventReset = "Azzera"
    override val eventLeadersEmptyWinGameShort = "Vinci un game per scalare la classifica"
    override val eventLeadersEmptyScoreFirst = "Segna per primo per guidare la classifica"
    override val eventLeadersEmptyTakeSetShort = "Conquista un set per prenderti la vetta"
    override val eventLeadersEmptyWinningAssist = "Fai l'assist decisivo"
    override val eventRatePlayersSubtitle = "Valuta i giocatori per aggiornare la classifica Top"
    override val eventGenericError = "Qualcosa è andato storto"
    override val eventDeleteTeamQuestion = "Eliminare la squadra?"
    override fun eventDeleteTeamMessage(teamName: String) = "\"$teamName\" sarà rimossa da questo evento. I giocatori assegnati resteranno senza squadra."
    override val eventPlayersTitle = "Giocatori"
    override fun eventApprovedCount(confirmed: Int, total: Int) = "($confirmed/$total approvati)"
    override val eventAwaitingPlayers = "In attesa di giocatori"
    override val eventAwaitingPlayersSubtitle = "Unisciti ora all'evento per iniziare a formare le squadre."
    override val eventAssignToTeam = "Assegna a una squadra"
    override val eventFormatLabel = "Formato:"
    override val eventProLabel = "Pro"
    override val eventTimeline = "Timeline"
    override val eventFormatAuto = "Auto"
    override val eventCoach = "Allenatore"
    override val eventSaving = "Salvataggio..."
    override val eventCreating = "Creazione..."
    override val eventSaveChanges = "Salva modifiche"
    override val eventCreateEvent = "Crea evento"
    override val eventEditEventTitle = "Modifica evento"
    override val eventErrorTitleRequired = "Il titolo è obbligatorio"
    override val eventErrorSportRequired = "Lo sport è obbligatorio"
    override val eventErrorSportNameRequired = "Il nome dello sport è obbligatorio"
    override val eventErrorFormatRequiredPro = "Il formato è obbligatorio per gli eventi Pro"
    override val eventErrorStartTimeRequired = "L'ora di inizio è obbligatoria"
    override val eventErrorEndTimeRequired = "L'ora di fine è obbligatoria"
    override val eventErrorEndAfterStart = "L'ora di fine deve essere successiva a quella di inizio"
    override val eventErrorStartInPast = "L'ora di inizio non può essere nel passato"
    override val eventErrorSelectAddress = "Seleziona un indirizzo"
    override val eventErrorAddressCity = "Scegli un indirizzo valido che includa una città"
    override val eventErrorCoverRequired = "La foto di copertina è obbligatoria"
    override val eventErrorSignInEdit = "Accedi per modificare gli eventi"
    override val eventErrorSignInCreate = "Accedi per creare eventi"
    override val eventErrorUploadImage = "Caricamento dell'immagine non riuscito"
    override val eventErrorSaveChanges = "Salvataggio delle modifiche non riuscito"
    override val eventErrorCreateEvent = "Creazione dell'evento non riuscita"
    override val eventAddressLabel = "Indirizzo"
    override val eventAddressPlaceholder = "Cerca un indirizzo..."
    override val eventTitleLabel = "Titolo"
    override val eventTitlePlaceholder = "es. Partita di calcio domenicale"
    override val eventSportNameLabel = "Nome dello sport"
    override val eventSportNamePlaceholder = "Inserisci il nome dello sport"
    override val eventMaxPlayersLabel = "Giocatori max"
    override val eventMaxPlayersPlaceholder = "es. 20"
    override val eventDateLabel = "Data"
    override val eventTimeFromLabel = "Dalle"
    override val eventTimeToLabel = "Alle"
    override val eventChooseOnMap = "Scegli sulla mappa"
    override val eventConfirmLocation = "Conferma posizione"
    override val eventAddPhoto = "Aggiungi foto"
    override val eventSportLabel = "Sport"
    override val eventLoading = "Caricamento..."
    override val eventSelectSportPlaceholder = "Seleziona sport"
    override val eventCommunityLabel = "Community"
    override val eventCommunityNone = "Nessuna (pubblico)"
    override val eventUnnamedGroup = "Gruppo senza nome"
    override val eventFormatFieldLabel = "Formato"
    override val eventSelectPlaceholder = "Seleziona"
    override val eventCostLabel = "Costo"
    override val eventPrivateLabel = "Privato"
    override val eventPrivateInfoDescription = "Gestisci la tua squadra approvando manualmente le richieste di partecipazione o rimuovendo i partecipanti."

    // subscription
    override val subscriptionTitle = "Arena Access"
    override val subscriptionActive = "Abbonamento attivo"
    override val subscriptionPrice = "${'$'}14.99/mese"
    override val subscriptionRequired = "Abbonati ad Arena Access per sbloccare gli eventi Pro, gli avatar IA e tutte le carte giocatore."
    override val subscribe = "Abbonati"
    override val subscriptionProcessing = "Elaborazione…"
    override val subscriptionBenefitProEvents = "Crea eventi Pro"
    override val subscriptionBenefitAvatars = "Genera avatar IA"
    override val subscriptionBenefitCards = "Sblocca tutte le carte giocatore"
    override val cancelSubscription = "Annulla abbonamento"
    override val manageSubscription = "Gestisci abbonamento"
    override val subscriptionCanceled = "Il tuo abbonamento è stato annullato."
    override val subscriptionActivated = "Arena Access è ora attivo. Buon divertimento!"
    override val subscriptionSignInRequired = "Accedi per abbonarti."
    override val subscriptionCheckoutFailed = "Qualcosa è andato storto. Riprova."
    override val subscriptionWillCancel = "Il tuo abbonamento non verrà rinnovato."
    override fun subscriptionRenewsOn(date: String) = "Rinnovo il $date"
    override fun subscriptionEndsOn(date: String) = "Accesso fino al $date"
    override val cardFrozenLabel = "Congelata"
    override val cardFrozen = "Rinnova per sbloccare"
    override val cardProPlus = "PRO+"

    // paywall
    override val paywallTitle = "Arena Pro +"
    override val paywallSubtitle = "Gioca come un pro. Appari come un pro."
    override val paywallFeaturePlayerCards = "Carte giocatore esclusive"
    override val paywallFeatureAiAvatar = "Generatore di avatar IA"
    override val paywallFeatureActivityLifestyle = "Attività e lifestyle"
    override val paywallFeatureProEvents = "Crea eventi Pro e aggiungi media"
    override val paywallFeatureNewsMatches = "Match Center: formazioni, statistiche e live"
    override fun paywallUpgradeCta(price: String) = "Passa a Pro a ${price}/mese"
    override fun paywallTrialCta(trialPrice: String) = "Attiva per $trialPrice"
    override fun paywallTrialTerms(trialPrice: String, price: String) = "Primi 3 giorni a $trialPrice, poi ${price}/mese fino alla disdetta."
    override val paywallCancelAnytime = "Disdici quando vuoi"
    override val paywallAutoRenew = "Si rinnova automaticamente ogni mese fino alla disdetta."
    override val paywallNewsSubtitle = "Segui ogni partita come un pro."
    override val paywallFeatureUnlimitedNews = "Feed di notizie illimitato"
    override val paywallFeatureHighlights = "Highlights video delle partite"
    override val paywallFeatureLineups = "Formazioni, statistiche e scontri diretti"
    override val paywallFeatureLiveScores = "Risultati live e cronologia della partita"
    override val paywallFeaturePlayerProfiles = "Profili dei giocatori e forma delle squadre"
    override val newsProBannerTitle = "Non perderti il seguito"
    override val newsProBannerSubtitle = "Sblocca il feed completo — tutte le notizie, risultati live, formazioni e statistiche con Arena Pro +"
    override val newsProBannerCta = "Sblocca con Arena Pro +"
    override val cardLifeGeneratePro = "Genera (Pro)"

    // gender
    override val profilePersonalEditGenderLabel = "Sesso"
    override val genderMale = "Uomo"
    override val genderFemale = "Donna"

    // nav
    override val navDashboard = "Dashboard"
    override val navClients = "Clienti"
    override val navChat = "Chat"
    override val navSchedule = "Calendario"
    override val navClubSettings = "Impostazioni club"
    override val navArena = "Arena"
    override val navFeed = "Feed"
    override val navNews = "Notizie"
    override val newsEmptyDay = "Nessuna notizia per questo giorno"
    override val newsOfDayTitle = "Notizie del giorno"
    override val newsTrendingTitle = "I più discussi"
    override val newsAllTitle = "Tutte le notizie"
    override val newsSortNew = "Nuove"
    override val newsSortPopular = "Popolari"
    override val newsMatchesTitle = "Partite"
    override val newsStandingsTitle = "Classifica"
    override val newsMatchOverview = "Panoramica"
    override val newsMatchLineups = "Formazioni"
    override val newsMatchSubstitutes = "Sostituzioni"
    override val newsMatchStats = "Statistiche"
    override val newsClubSquad = "Rosa"
    override val newsClubLastMatches = "Ultime partite"
    override val newsClubNextMatches = "Prossime partite"
    override val newsClubFounded = "Fondato"
    override val newsDetailUnavailable = "Dettagli non disponibili"
    override val newsWatchOnYoutube = "Guarda su YouTube"
    override val newsArticleMatch = "Partita"
    override val newsArticleHighlights = "Highlights"
    override val newsMatchH2h = "Scontri diretti"
    override val newsLeagueAll = "Tutte"
    override val newsStPlayed = "G"
    override val newsStWin = "V"
    override val newsStDraw = "N"
    override val newsStLoss = "P"
    override val newsStPts = "Pti"
    override val newsNoMatches = "Nessuna partita per questo giorno"
    override val newsSortLabel = "Ordina"
    override val newsSortFavorites = "Preferite"
    override val newsToday = "Oggi"
    override val newsTomorrow = "Domani"
    override val newsYesterday = "Ieri"
    override val newsFilterFinished = "Finite"
    override val newsFilterUpcoming = "In programma"
    override val newsStGoals = "Gol"
    override val newsZoneCl = "Champions League"
    override val newsZoneEl = "Europa League"
    override val newsZoneRelegation = "Retrocessione"
    override val newsFilterStatusTitle = "Stato"
    override val newsFilterLeaguesTitle = "Leghe e tornei"
    override val newsNextMatches = "Prossime partite"
    override val newsRelatedTitle = "Notizie correlate"
    override val newsSourceLabel = "Fonte"
    override val navPeople = "Persone"
    override val navProfile = "Profilo"
    override val navStatistic = "Statistiche"
    override val navTeam = "Squadra"
    override val navMedia = "Media"
    override val navWeek = "Settimana"
    override val navMonth = "Mese"
    override val navYear = "Anno"

    // modal
    override val modalDecline = "Rifiuta"
    override val modalCompleteSession = "Completa sessione"
    override val modalTimeAlt = "Orario"
    override val modalPriceAlt = "Prezzo"
    override val modalBookings = "Prenotazioni"
    override val modalTotalSpent = "Totale speso"
    override val modalSendMessage = "Invia messaggio"
    override val modalAddNote = "Aggiungi nota"
    override val modalAdminNotes = "Note admin"
    override val modalAdminNotesPrivacy = "Privato: visibile solo agli admin"
    override val modalWriteNotePlaceholder = "Scrivi una nota..."
    override val modalAdd = "Aggiungi"
    override val modalBookingHistory = "Cronologia prenotazioni"
    override val modalNoBookingsYet = "Ancora nessuna prenotazione"
    override val modalFieldFallback = "Campo"
    override val modalStatusConfirmed = "Confermata"
    override val modalStatusPending = "In attesa"
    override val modalStatusCompleted = "Completata"
    override val modalStatusCancelled = "Annullata"
    override val modalPaid = "Pagato"
    override val modalUnpaid = "Non pagato"

    // feed
    override val feedClubBadge = "Club"
    override fun feedAddAllPhotos(count: Int) = "Aggiungi tutte le $count foto"
    override val feedUploadFailed = "Caricamento non riuscito"
    override val feedCreatePostFailed = "Creazione del post non riuscita"
    override val feedCreatePostTitle = "Crea post"
    override val feedChooseLayoutSubtitle = "Scegli un layout per il tuo post"
    override val feedFileTooLarge = "File troppo grande (max 50 MB)"
    override val feedChooseLayout = "Scegli un layout"
    override val feedCreating = "Creazione..."
    override val feedAddPhoto = "Aggiungi foto"
    override val feedCityLabel = "Città"
    override val feedEnterCityPlaceholder = "Inserisci il nome della città..."
    override val feedPostContentLabel = "Contenuto del post"
    override val feedPostContentPlaceholder = "Scrivi qualcosa su questo post..."
    override val feedOptional = "(Facoltativo)"
    override val feedPickPhotoFirst = "Scegli prima una foto"
    override val feedCreateStoryFailed = "Creazione della storia non riuscita"
    override val feedCreateStoriesTitle = "Crea storie"
    override val feedCreateStoriesSubtitle = "Crea e condividi i tuoi momenti"
    override val feedFileTooLargeStory = "File troppo grande (max 30 MB)"
    override val feedDropContentHere = "Trascina qui il tuo contenuto"
    override val feedMaxStorySize = " max 30 MB"
    override val feedFollowingSection = "Seguiti"
    override val feedFollowersSection = "Follower"
    override val feedSearching = "Ricerca…"
    override val feedNoResults = "Nessun risultato"
    override val feedLoadingMore = "Caricamento altri…"
    override val feedThisUser = "questo utente"
    override fun feedUnfollowTitle(name: String) = "Smettere di seguire $name?"
    override val feedUnfollowSubtitle = "Puoi tornare a seguire quando vuoi."
    override val feedUnfollow = "Smetti di seguire"
    override fun feedRemoveTitle(name: String) = "Rimuovere $name?"
    override val feedRemoveSubtitle = "Non riceverà notifiche, ma non vedrà più i tuoi post."
    override val feedRemove = "Rimuovi"
    override val feedFollow = "Segui"
    override val feedDeleted = "Eliminato"
    override val feedNotFollowingTitle = "Non segui ancora nessuno"
    override val feedNotFollowingBody = "Segui i giocatori per vedere nel tuo feed i loro ultimi post, highlights e storie."
    override val feedNoFollowersTitle = "Ancora nessun follower"
    override val feedNoFollowersBody = "Condividi i post e le storie delle tue partite per farti notare dalla community."
    override val feedDiscoverPlayers = "Scopri giocatori"

    // dropdown
    override val dropdownAllCities = "Tutte le città"
    override val dropdownSelectedAlt = "Selezionato"

    // page
    override val pageScheduleTitle = "Calendario"
    override val pageScheduleComingSoon = "La vista calendario arriva presto"
    override val pageEventsSeoTitle = "Eventi sportivi"
    override val pageEventsSeoDescription = "Sfoglia e partecipa agli eventi sportivi vicino a te: calcio, tennis, basket, padel e altro. Crea la tua partita e invita i giocatori su Arena."
    override val pageEventsTitle = "Eventi"
    override val pageCreateEvent = "Crea evento"
    override val pageNoEventsYet = "Ancora nessun evento"
    override val pageNotFoundTitle = "Ops, pagina non trovata"
    override val pageNotFoundBody = "Controlla che l'indirizzo della pagina sia corretto o torna all'arena principale."
    override val pageBackToArena = "Torna all'Arena"
    override val pageChatTitle = "Chat"
    override val pageLoading = "Caricamento..."
    override val pageSomethingWentWrong = "Qualcosa è andato storto"
    override fun pageUnfollowTitle(name: String) = "Smetti di seguire $name"
    override val pageRemoveFollowerTitle = "Rimuovere il follower?"
    override fun pageRemoveFollowerSubtitle(name: String) = "Non avviseremo $name di questa modifica."
    override val pageFeedTitle = "Feed"
    override val pageFeedSeoDescription = "Scopri cosa fa la community sportiva di Arena: risultati delle partite, highlights e momenti condivisi dai giocatori vicino a te."
    override val pageNoPostsYet = "Ancora nessun post"
    override val pageLoadingMore = "Caricamento altri..."
    override val pagePeopleSeoTitle = "Trova giocatori"
    override val pagePeopleSeoDescription = "Scopri atleti vicino a te, fai match con giocatori del tuo livello e fai squadra per la tua prossima partita su Arena."
    override val pagePeopleTitle = "Persone"
    override val pageSquadUpTitle = "Fai squadra"
    override val pageSquadUpSubtitle = "Trova partner, connettiti con i giocatori e inizia la partita."
    override val pagePeopleLoadFailed = "Impossibile caricare le persone"
    override val pagePeopleCaughtUpTitle = "Per ora hai visto tutti"
    override val pagePeopleCaughtUpSubtitle = "Torna più tardi per altri giocatori."
    override val pageRefresh = "Aggiorna"
    override val pageClientsTitle = "Clienti"
    override fun pageClientsTotal(total: Int) = "$total clienti in totale"
    override val pageActiveClients = "Clienti attivi"
    override val pageTotalBookings = "Prenotazioni totali"
    override val pageTotalRevenue = "Ricavi totali"
    override val pageStatusVip = "VIP"
    override val pageStatusActive = "Attivo"
    override val pageStatusDebtor = "Debitore"
    override val pageStatusAll = "Tutti gli stati"
    override val pageStatusInactive = "Inattivo"
    override val pageAddNewClient = "Aggiungi nuovo cliente"
    override val pageColName = "Nome"
    override val pageColRevenue = "Ricavi"
    override val pageColStatus = "Stato"
    override val pageColLastVisit = "Ultima visita"
    override val pageColActions = "Azioni"
    override val pageUnpaidSuffix = "non pagato"
    override val pagePrevious = "Precedente"
    override val pagePageLabel = "Pagina"
    override val pageOfLabel = "di"
    override val pageBackToEvents = "Torna agli eventi"
    override val pageBackToClubs = "Torna ai club"
    override val pageResetTimerTitle = "Azzerare il timer?"
    override val pageResetTimerMessage = "Il cronometro della partita torna a 00:00. Le statistiche registrate restano invariate."
    override val pageResetTimerConfirm = "Azzera"
    override val pageResetting = "Azzeramento..."
    override val pageEndMatchTitle = "Terminare la partita?"
    override val pageEndMatchMessage = "L'evento sarà contrassegnato come concluso e i punteggi verranno bloccati."
    override val pageEndMatchConfirm = "Termina partita"
    override val pageEnding = "Chiusura..."
    override val pageAddMedia = "Aggiungi media"
    override val pageBook = "Prenota"
    override val pageCourtRules = "Regole del campo"
    override val pageNoCourtRules = "Nessuna regola del campo specificata."
    override val pageLeaveReview = "Lascia una recensione"
    override val pageNoReviewsYet = "Ancora nessuna recensione."
    override val pageSportFootball = "Calcio"
    override val pageSportBasketball = "Basket"
    override val pageSportTennis = "Tennis"
    override val pageSportPadel = "Padel"
    override val pageClubFallback = "Club"
    override fun pageReviewExperienceTitle(sportName: String) = "Com'è andata la tua esperienza con $sportName?"
    override val pageWriteReviewPlaceholder = "Scrivi la tua recensione..."
    override val pagePosting = "Pubblicazione..."
    override val pagePostReview = "Pubblica recensione"
    override val pageLoadMore = "Carica altri"
    override val pageArenaSeoTitle = "Arena"
    override val pageArenaSeoDescription = "La tua carriera sportiva a colpo d'occhio: statistiche, rating e traguardi in calcio, tennis, basket e altro su Arena."
    override val pageEventsTab = "Eventi"
    override val pageClubsTab = "Club"
    override val pageFilterLocation = "Posizione"
    override val pageUnnamedCommunity = "Senza nome"
    override val pageFilterCommunity = "Community"
    override val pageFilterAll = "Tutte"
    override val pageFilterCalendar = "Calendario"
    override val pageAddEvent = "Aggiungi evento"
    override val pageAddClub = "Aggiungi club"
    override val pageMap = "Mappa"
    override val pageList = "Elenco"
    override val pageOwnTheArena = "DOMINA L'ARENA"
    override val pageArenaBannerSubtitle = "La tua arena ti aspetta. Prenota all'istante, gioca senza pensieri."
    override val pageLoadingMoreEvents = "Caricamento altri eventi..."
    override val pageLoadingMoreClubs = "Caricamento altri club..."
    override val pageNoClubsYet = "Ancora nessun club"
    override val pageClubsWillAppear = "I club appariranno qui"
    override val pageEventsMapTitle = "Mappa eventi"
    override val pageClubsMapTitle = "Mappa club"
    override val pageDeleteClub = "Elimina club"
    override val pageAddBanner = "Aggiungi banner"
    override val pageRulePlaceholder = "es. Abbigliamento sportivo obbligatorio"
    override val pageAddRule = "Aggiungi regola"
    override val pageEditServices = "Modifica servizi"
    override val pageManageServices = "Gestisci servizi"
    override val pageAmenityParking = "Parcheggio"
    override val pageAmenityCafe = "Bar"
    override val pageAmenityWifi = "WiFi"
    override val pageAmenityReception = "Reception"
    override val pageAmenityShower = "Docce"
    override val pageAmenityFirstAid = "Pronto soccorso"
    override val pageReviewsLabel = "Recensioni:"
    override val pageAvgRatingLabel = "Val. media:"
    override val pageReviewsPlaceholderNote = "Le recensioni appariranno qui quando gli utenti lasceranno un feedback."
    override val pageClubComposePrompt = "Che succede nel tuo club?"
    override val pageClubNoPostsHint = "Condividi una foto e due righe per tenere vivo il club."
    override val pageComposePostTitle = "Scrivi post"
    override val pagePostContentPlaceholder = "Contenuto del post..."
    override fun pageAddImageSlot(slot: Int) = "Aggiungi immagine $slot"
    override val pagePostAction = "Pubblica"
    override val pageEditClubInfo = "Modifica info club"
    override val pageClubNameLabel = "Nome del club"
    override val pageAddressLabel = "Indirizzo"
    override val pageSearchAddressPlaceholder = "Cerca un indirizzo"
    override val pageSaveChanges = "Salva modifiche"

    // account
    override val accountRequiredTitle = "Account richiesto"
    override val accountRequiredDescription = "Questa funzione è solo per i giocatori registrati. Accedi con Google o Apple per continuare."
    override val accountRequiredTermsPrefix = "Continuando accetti i nostri "
    override val accountRequiredTerms = "Termini"
    override val accountRequiredPrivacy = "Privacy"

    // avatar
    override val avatarGenTitle = "Avatar AI"
    override val avatarGenErrorFileType = "Sono consentiti solo file JPEG, PNG e WebP"
    override val avatarGenErrorFileSize = "Il file deve essere inferiore a 30 MB"
    override val avatarGenErrorNoPerson = "Non abbiamo trovato nessuna persona in questa foto. Provane un'altra."
    override val avatarGenErrorFailed = "Generazione non riuscita. Prova un'altra foto o un altro prompt."
    override val avatarGenGenerating = "Generazione…"
    override val avatarGenGeneratingHint = "Potrebbe richiedere fino a 30 secondi"
    override val avatarGenGenerate = "Genera"
    override val avatarGenGeneratedLook = "Look generato"
    override val avatarGenDropPhotoHere = "Trascina qui la tua foto"
    override val avatarGenMaxFileSize = "max 30 MB"
    override val avatarGenReadyToGenerate = "Pronto per generare"
    override val avatarGenCustomPrompt = "Prompt personalizzato"
    override val avatarGenPromptPlaceholder = "Aggiungi dettagli per definire lo stile ..."
    override val avatarGenInfoDefaultBehavior = "Per impostazione predefinita l'AI ti ritaglierà dalla foto e ti posizionerà sulla card."
    override val avatarGenInfoPromptIntro = "Nel prompt puoi anche chiedere di:"
    override val avatarGenInfoBulletZoom = "Ingrandire o rimpicciolire la figura"
    override val avatarGenInfoBulletObject = "Aggiungere o rimuovere un oggetto (es. occhiali da sole, maglia, palla, cappello)"
    override val avatarGenOptionalBadge = "(Facoltativo)"

    // card
    override val cardLifeTitle = "Dai vita alla tua card"
    override val cardLifeSubtitle = "Crea la tua identità visiva"
    override val cardLifeMyStyles = "I miei stili"
    override val cardLifeSelectToGenerate = "Seleziona per generare"
    override val cardLifeActiveCards = "Card profilo attive"
    override val cardLifeDragToReorder = "Trascina per riordinare"
    override val cardLifeNoTemplates = "Ancora nessun template di card. Prendine uno nel Card Shop."
    override val cardLifeCreatePhoto = "Crea foto"
    override val cardLifeDeleteCardTitle = "Eliminare la card?"
    override val cardLifeDeleteCardMessage = "Questo rimuove la card dalla tua galleria. Il template resta nei tuoi stili."

    // complete
    override val completeProfileTitle = "Completa il profilo per iniziare lo swipe"
    override val completeProfileDescription = "Completa il profilo per vedere giocatori con il tuo livello e interessi in comune."
    override val completeProfileMaybeLater = "Magari più tardi"
    override val completeProfileAction = "Completa profilo"

    // preference
    override val preferenceDetailsTitle = "Dettagli delle preferenze"

    // follow
    override val followListFollowers = "Follower"
    override val followListFollowing = "Seguiti"
    override val followListNoResults = "Nessun risultato"
    override val followListNoFollowersYet = "Ancora nessun follower"
    override val followListNotFollowingAnyoneYet = "Non segui ancora nessuno"
    override val followListUnfollow = "Smetti di seguire"
    override val followListFollow = "Segui"
    override val followListRemove = "Rimuovi"
    override val followListDeleted = "Eliminato"

    // interactions
    override val interactionsTitle = "Interazioni"
    override fun interactionsSubtitle(newLikes: Int, matches: Int) = "$newLikes nuovi Mi piace · $matches match"
    override val interactionsNewLikes = "Nuovi Mi piace"
    override val interactionsNoNewLikesTitle = "Ancora nessun nuovo Mi piace"
    override val interactionsNoNewLikesMessage = "Quando qualcuno fa swipe su Sì per te, apparirà qui."
    override val interactionsMatches = "Match"
    override val interactionsNoMatchesTitle = "Ancora nessun match"
    override val interactionsNoMatchesMessage = "Fai swipe su Sì a qualcuno che ti ha già messo Mi piace per ottenere un match."

    // match
    override val matchItsWord = "È"
    override val matchWord = "MATCH"
    override val matchSubtitle = "È ora di conoscervi e organizzare la vostra partita."
    override val matchKeepSwiping = "Continua lo swipe"
    override val matchGoToProfile = "Vai al profilo"
    override val matchYouFallback = "Tu"

    // purchase
    override val purchaseCardTitle = "Vuoi questa card?"
    override val purchaseCardBuying = "Acquisto…"
    override val purchaseCardBuyNow = "Acquista ora"

    // post
    override val postCommentsLike = "Mi piace"
    override val postCommentsOneLike = "1 Mi piace"
    override fun postCommentsLikes(count: Int) = "$count Mi piace"
    override val postCommentsInputPlaceholder = "Scrivi un messaggio…"

    // story
    override fun storySeenBy(count: Int) = "Visto da $count"

    // support
    override val supportTitle = "Contatta l'assistenza"
    override val supportIntro = "Raccontaci cosa è andato storto o per cosa ti serve aiuto: ti risponderemo via email."
    override val supportEmailLabel = "La tua email"
    override val supportMessageLabel = "Messaggio"
    override val supportMessagePlaceholder = "Descrivi il problema…"
    override val supportErrorInvalidEmail = "Inserisci un'email valida."
    override val supportErrorEmptyMessage = "Scrivi un messaggio."
    override val supportErrorGeneric = "Qualcosa è andato storto. Riprova."
    override val supportSending = "Invio…"
    override val supportSendMessage = "Invia messaggio"
    override val supportSentTitle = "Messaggio inviato!"
    override val supportSentMessage = "Grazie per averci scritto: ti risponderemo presto via email."

    // person
    override val personDetailTabAbout = "Info"
    override val personDetailTabPosts = "Post"
    override val personDetailTabAchievement = "Traguardi"
    override val personDetailAchievementsComingSoon = "Traguardi in arrivo."
    override val personDetailFollowing = "Seguiti"
    override val personDetailFollowers = "Follower"
    override val personDetailSportLabel = "Sport:"
    override val personDetailActivityLabel = "Attività:"
    override val personDetailLifestyleLabel = "Lifestyle:"
    override val personDetailNoPostsTitle = "Ancora nessun post"
    override val personDetailNoPostsMessage = "Questo giocatore non ha ancora pubblicato nulla."

    // common
    override val commonClose = "Chiudi"
    override val commonDone = "Fatto"
    override val commonLoading = "Caricamento…"
    override val commonBack = "Indietro"
    override val commonSkip = "Salta"

    // profile
    override val profileCardShopLoading = "Caricamento..."
    override val profileCardShopEmpty = "Nessuna card disponibile"
    override val profileCardShopBuy = "Acquista"
    override val profileCardShopFree = "Gratis"
    override val profileFormationReservePlate = "Ris"
    override val profileFormationCoach = "Allenatore"
    override val profileMediaEmpty = "Ancora nessun media"
    override val profileMediaImageAlt = "media"
    override val profileNewsPrompt = "A cosa stai pensando?"
    override val profileNewsLoading = "Caricamento..."
    override val profileNewsLoginRequired = "Accedi per vedere i tuoi post"
    override val profileNewsEmpty = "Ancora nessun post. Condividi qualcosa!"
    override val profileNewsPlaceholder = "Scrivi qualcosa..."
    override val profileNewsPosting = "Pubblicazione..."
    override val profileNewsPost = "Pubblica"
    override val profileRadarTitle = "Radar"
    override val profileRecentMatchesTitle = "Eventi recenti"
    override val profileRecentMatchesEmptyTitle = "Ancora nessun evento in programma"
    override val profileRecentMatchesEmptyHint = "Scegli un evento in arrivo e unisciti all'azione!"
    override fun profileRecentMatchesSportPro(sport: String) = "$sport · Pro+"
    override val profileRecentMatchesTeamA = "Squadra A"
    override val profileRecentMatchesTeamB = "Squadra B"
    override fun profileRecentMatchesPeopleCount(count: Int) = "$count pers."
    override val profileRecentMatchesWin = "Vittoria"
    override val profileRecentMatchesLoss = "Sconfitta"
    override val profileRecentMatchesDraw = "Pareggio"
    override val profileRecentMatchesSportFallback = "Sport"
    override val profileRecentMatchesProPlus = "Pro+"
    override fun profileRecentMatchesFormat(format: Int) = "Formato $format X $format"
    override fun profileRecentMatchesMembers(count: Int) = "$count membri"
    override val profileShortcutStatistic = "Statistiche"
    override val profileShortcutMedia = "Media"
    override val profileStatsChartsGoals = "Gol"
    override val profileStatsChartsAssists = "Assist"
    override val profileStatsChartsPerYear = "all'anno"
    override val profileStatsChartsPerWeek = "a settimana"
    override val profileStatsChartsPerMonth = "al mese"
    override fun profileStatsChartsTitle(stat: String, period: String) = "$stat $period"
    override val profileStatsChartsNoData = "Nessun dato disponibile"
    override val profileTeamEmptyOwnTitle = "Non hai ancora una squadra"
    override val profileTeamEmptyOtherTitle = "Nessuna squadra"
    override val profileTeamEmptyCreateTeam = "Crea squadra"
    override val profileTrackerTitle = "Tracker"
    override val profileTrackerWorldMap = "Mappa del mondo"
    override val profileTeamMatchesEmpty = "Ancora nessuna partita"
    override val profileTeamMatchesUpcomingTitle = "Prossime partite"
    override val profileTeamMatchesUpcomingEmpty = "Nessuna partita in programma"
    override val profileTeamMatchesVenueAlt = "Luogo"
    override fun profileTeamMatchesTeamsCount(count: Int) = "$count squadre"
    override fun profileTeamMatchesMembersCount(current: Int, total: Int) = "$current/$total membri"
    override fun profileTeamMatchesFormat(format: Int) = "Formato ${format}x${format}"
    override val profileTeamOverviewTitle = "Panoramica della squadra"
    override val profileTeamOverviewClubTitle = "Club di calcio"
    override val profileTeamOverviewRating = "Rating"
    override val profileTeamOverviewTeamRating = "Rating della squadra"
    override val profileTeamOverviewStatistics = "Statistiche"
    override val profileTeamOverviewWins = "Vittorie"
    override val profileTeamOverviewDraws = "Pareggi"
    override val profileTeamOverviewLosses = "Sconfitte"
    override val profileSidebarTitle = "Panoramica"
    override val profileSidebarFollowing = "Seguiti"
    override val profileSidebarFollowers = "Follower"
    override val profileSidebarAchievement = "Traguardi"
    override val profileSidebarAboutYouEmpty = "Aggiungi qualche parola su di te per presentare il tuo profilo"
    override val profileSidebarFocusActivities = "Focus & attività"
    override val profileSidebarSportLabel = "Sport"
    override val profileSidebarActivityLabel = "Attività"
    override val profileSidebarLifestyleLabel = "Lifestyle"
    override val profileSidebarChat = "Chat"
    override val profileSidebarFollow = "Segui"
    override val profileSidebarUnfollow = "Smetti di seguire"
    override val profileSidebarNoInterests = "Nessun interesse aggiunto"
    override val profileSidebarNoInterestsBody = "Mostra agli altri i tuoi hobby e i tuoi sport."
    override val profileHubTitle = "Player Hub"
    override val profileHubYourStories = "Le tue storie"
    override val profileHubStories = "Storie"
    override val profileHubCardShopUnavailable = "Card Shop non disponibile"
    override val profileHubCardShopTitle = "Card Shop"
    override val profileHubCardShopSubtitle = "Acquista nuove card. Definisci il tuo stile."
    override val profileHubActiveBought = "Attive & acquistate"
    override fun profileHubOwnedCount(count: Int) = "$count possedute"
    override val profileHubNoCardsYet = "Ancora nessuna card"
    override val profileHubAvailableForPurchase = "Disponibili per l'acquisto"
    override val profileHubNewDesignsRegularly = "Nuovi design regolarmente"
    override val profileHubAllCardsOwned = "Possiedi già tutte le card"
    override fun profileHubChartTitle(stat: String, period: String) = "$stat per $period"
    override val profileHubNoChartsTitle = "Nessun grafico disponibile"
    override val profileHubNoChartsBody = "Scegli uno sport specifico nell'header per vedere gol, assist, partite e il resto delle tue statistiche."
    override val profileHubContentTitle = "Contenuti"
    override val profileHubLoading = "Caricamento..."
    override val profileHubAddStory = "Aggiungi storia"
    override val profileHubAddPost = "Aggiungi post"
    override val profileHubUserFallback = "utente"
    override val profileHubNoPostsYet = "Ancora nessun post"
    override val profileHubShareFirstMoment = "Condividi il tuo primo momento"
    override val profileHubPlayerNotPosted = "Questo giocatore non ha ancora pubblicato."
    override val profileOverviewTitle = "Panoramica giocatore"
    override val profileOverviewPlayerIdentify = "Identità del giocatore"
    override val profileOverviewChat = "Chat"
    override val profileOverviewAiAvatar = "Avatar AI"
    override val profileOverviewGoals = "Gol"
    override val profileOverviewGoalsUnit = "gol"
    override val profileOverviewWins = "Vittorie"
    override val profileOverviewWinsUnit = "vittorie"
    override val profileOverviewDraws = "Pareggi"
    override val profileOverviewDrawsUnit = "pareggi"
    override val profileOverviewLosses = "Sconfitte"
    override val profileOverviewLossesUnit = "sconfitte"
    override val profileOverviewAchievements = "Traguardi"
    override val profileOverviewNotFollowingAnyone = "Non segui ancora nessuno"
    override val profileOverviewComingSoon = "In arrivo"
    override val profileAwardsEmpty = "Ancora nessun premio"
    override val awardWelcomeTitle = "Premio di benvenuto"
    override val awardTermScorerFootball = "Capocannoniere"
    override val awardTermAssistFootball = "Miglior assistman"
    override val awardTermScorerBasketball = "Miglior marcatore"
    override val awardTermAssistBasketball = "Migliori assist"
    override val awardTermScorerTennis = "Più vincenti"
    override val awardTermAssistTennis = "Più ace"
    override val awardTermScorerVolleyball = "Miglior attaccante"
    override val awardTermAssistVolleyball = "Migliori assist"
    override val awardTermScorerPadel = "Più vincenti"
    override val awardTermAssistPadel = "Più smash"
    override val awardTermScorerGeneric = "Capocannoniere"
    override val awardTermAssistGeneric = "Migliori assist"
    override val awardRank1 = "1º posto"
    override val awardRank2 = "2º posto"
    override val awardRank3 = "3º posto"
    override val profileOverviewAddPost = "Aggiungi post"
    override val profileOverviewWritePlaceholder = "Scrivi qualcosa..."
    override val profileOverviewPost = "Pubblica"
    override val profileOverviewLoading = "Caricamento..."
    override val profileOverviewLoginToSeePosts = "Accedi per vedere i post"
    override val profileOverviewNoPostsYet = "Ancora nessun post"
    override val profileWizardLetsGo = "Si parte!"
    override val profileWizardStepPersonalInfoTitle = "Informazioni personali"
    override val profileWizardStepPersonalInfoDescription = "Raccontaci di te per iniziare."
    override val profileWizardStepFocusTitle = "Focus & attività"
    override val profileWizardStepFocusDescription = "Scegli i tuoi sport e il tuo lifestyle"
    override val profileWizardStepCardTitle = "Dai vita alla tua card"
    override val profileWizardStepCardDescription = "Crea la tua identità visiva"
    override fun profileWizardSelectedCount(count: Int) = "$count selezionati"
    override val profileWizardPublicInfo = "Info pubbliche"
    override val profileWizardMyStyles = "I miei stili"
    override val profileWizardSelectToGenerate = "Seleziona per generare"
    override val profileWizardNoTemplates = "Nessun template di card disponibile al momento."
    override val profileWizardActiveCards = "Card profilo attive"
    override val profileWizardDragToReorder = "Trascina per riordinare"
    override fun profileWizardCardCount(count: Int) = "$count card"
    override val profileWizardCreatePhoto = "Crea foto"
    override val profileFocusEditTitle = "Focus & attività"
    override val profileFocusEditDescription = "Scegli i tuoi sport e il tuo lifestyle per definire la tua identità."
    override val profileFocusEditSelectedLabel = "selezionati"
    override val profileFocusEditClearAll = "Cancella tutto"
    override val profileFocusEditSearchPlaceholder = "Cerca attributi…"
    override val profileFocusEditSportLabel = "Sport"
    override val profileFocusEditActivityLabel = "Attività"
    override val profileFocusEditLifestyleLabel = "Lifestyle"
    override val profileFocusEditNoMatches = "Nessuna corrispondenza"
    override val profileFocusEditPreferenceDetails = "Dettagli delle preferenze"
    override val profileFocusEditPreferenceHint = "Facoltativo, ma ti aiuta a trovare più in fretta persone affini."
    override val profileFocusEditNoteLabel = "Nota"
    override val profileFocusEditNotePlaceholder = "Cosa stai cercando?"
    override val profileFocusEditAddDetails = "Aggiungi dettagli"
    override val profilePersonalEditTitle = "Informazioni personali"
    override val profilePersonalEditDescription = "Raccontaci di te per iniziare."
    override val profilePersonalEditFirstNameLabel = "Nome"
    override val profilePersonalEditLastNameLabel = "Cognome"
    override val profilePersonalEditAboutMeLabel = "Su di me"
    override val profilePersonalEditBioPlaceholder = "Racconta qualcosa di te agli altri giocatori…"
    override val profilePersonalEditDobLabel = "Data di nascita"
    override val profilePersonalEditDobInvalid = "Inserisci una data valida"
    override val profilePersonalEditDobFuture = "La data di nascita non può essere nel futuro"
    override val profilePersonalEditCityLabel = "Città"
    override val profilePersonalEditCitySearchPlaceholder = "Cerca città…"
    override val profilePersonalEditLanguagesLabel = "Lingue"
    override val profilePersonalEditTypeLanguagePlaceholder = "Scrivi una lingua…"
    override val profilePersonalEditAddLanguagePlaceholder = "Aggiungi lingua"
    override val profileEditSheetPublicInfo = "Info pubbliche"
    override val profileEditShellPublicInfo = "Info pubbliche"
    override fun profileCreatePostAddAllPhotos(count: Int) = "Aggiungi tutte le $count foto"
    override val profileCreatePostUploadFailed = "Caricamento non riuscito"
    override val profileCreatePostCreateFailed = "Creazione del post non riuscita"
    override val profileCreatePostTitle = "Crea post"
    override val profileCreatePostChooseLayout = "Scegli un layout"
    override val profileCreatePostFileTooLarge = "File troppo grande (max 50 MB)"
    override val profileCreatePostCreating = "Creazione..."
    override val profileCreatePostAddPhoto = "Aggiungi foto"
    override val profileCreatePostContentLabel = "Contenuto del post"
    override val profileCreatePostContentPlaceholder = "Scrivi qualcosa su questo post..."
    override val profileCreatePostCityLabel = "Città"
    override val profileCreatePostCityPlaceholder = "Inserisci il nome della città..."
    override val profileCreateStoryPickPhotoFirst = "Scegli prima una foto"
    override val profileCreateStoryUploadFailed = "Caricamento non riuscito"
    override val profileCreateStoryCreateFailed = "Creazione della storia non riuscita"
    override val profileCreateStoryTitle = "Crea storie"
    override val profileCreateStorySubtitle = "Crea e condividi i tuoi momenti"
    override val profileCreateStoryFileTooLarge = "File troppo grande (max 30 MB)"
    override val profileCreateStoryCreating = "Creazione..."
    override val profileCreateStoryDropHere = "Trascina qui il tuo contenuto"
    override val profileCreateStoryMaxSize = " max 30 MB"
    override val profileFollowListFollowers = "Follower"
    override val profileFollowListFollowing = "Seguiti"
    override val profileFollowListNoResults = "Nessun risultato"
    override val profileFollowListUnfollow = "Smetti di seguire"
    override val profileFollowListFollow = "Segui"
    override val profileFollowListRemoved = "Rimosso"
    override val profileFollowListRemove = "Rimuovi"
    override val profileFollowListNotFollowingTitle = "Non segui ancora nessuno"
    override val profileFollowListNotFollowingBody = "Segui i giocatori per vedere nel tuo feed i loro ultimi post, highlights e storie."
    override val profileFollowListDiscoverPlayers = "Scopri giocatori"
    override val profileFollowListNoFollowersTitle = "Ancora nessun follower"
    override val profileFollowListNoFollowersBody = "Condividi i post e le storie delle tue partite per farti notare dalla community."
    override val profileDialogPreferenceDetails = "Dettagli delle preferenze"
    override val profileStoryViewersTitle = "Chi ha visto questa storia?"
    override val profileStoryViewersNoViews = "Ancora nessuna visualizzazione"
    override val profileContentMobileOverview = "Panoramica"
    override val profileContentMobileFollowing = "Seguiti"
    override val profileContentMobileFollowers = "Follower"
    override val profileContentMobileAwardsComingSoon = "Premi in arrivo"
    override val profileContentMobileRecentEvents = "Eventi recenti"
    override val profileContentMobileNoEvents = "Ancora nessun evento in programma"
    override val profileContentMobileNoEventsBody = "Scegli un evento in arrivo e unisciti all'azione!"
    override val profileContentMobileResultWin = "Vittoria"
    override val profileContentMobileResultDraw = "Pareggio"
    override val profileContentMobileResultLoss = "Sconfitta"
    override val profileContentMobileSportFallback = "Sport"
    override fun profileContentMobileFormat(format: Int) = "Formato $format X $format"
    override fun profileContentMobileMembers(count: Int) = "$count membri"
    override val profileContentMobilePlayerHub = "Player Hub"
    override val profileContentMobileNoPostsTitle = "Ancora nessun post"
    override val profileContentMobileNoPostsOwnBody = "Condividi foto e highlights delle partite per riempire il tuo profilo."
    override val profileContentMobileNoPostsOtherBody = "Questo giocatore non ha ancora pubblicato nulla."
    override val profileContentMobileCardsUnavailable = "Card non disponibili"
    override val profileContentMobileCardsLoadFailed = "Caricamento delle card non riuscito"
    override val profileContentMobileNoCardsAvailable = "Nessuna card disponibile"
    override val profileContentMobileActiveBought = "Attive & acquistate"
    override fun profileContentMobileOwnedCount(count: Int) = "$count possedute"
    override val profileContentMobileAvailableForPurchase = "Disponibili per l'acquisto"
    override val profileContentMobileNewDesigns = "Nuovi design regolarmente"
    override val profileContentMobileNoCardsYet = "Ancora nessuna card"
    override val profileContentMobileCardsTitle = "Card"
    override val profileContentMobileAddPost = "Aggiungi post"
    override val profileContentMobileUserFallback = "utente"
    override val profileUserSheetError = "Qualcosa è andato storto"
    override val profileUserSheetThisUser = "questo utente"
    override fun profileUserSheetUnfollowTitle(name: String) = "Smettere di seguire $name?"
    override val profileUserSheetRefollowHint = "Puoi tornare a seguire quando vuoi."
    override val profileUserSheetUnfollow = "Smetti di seguire"

    // header
    override val headerNavHome = "Home"
    override val headerNavAbout = "Chi siamo"
    override val headerNavServices = "Servizi"
    override val headerNavProjects = "Progetti"
    override val headerNavContacts = "Contatti"
    override val headerSportLabel = "Sport:"
    override val headerUserFallbackName = "Utente"
    override val headerNoActiveEvents = "Nessun evento o prenotazione attiva"
    override val headerNoNotifications = "Nessuna notifica"
    override val headerYourActiveEvents = "I tuoi eventi attivi "
    override val headerNotificationsTitle = "Notifiche "
    override val headerMarkAllRead = "Segna tutte come lette"
    override val headerLoadMore = "Carica altri"
    override val headerPendingApproval = "In attesa di approvazione"
    override val headerEventStatusNew = "Nuovo"
    override val headerEventStatusInProgress = "In corso"
    override val headerEventStatusCompleted = "Concluso"
    override val headerEventStatusCancelled = "Annullato"
    override val headerBookingFallback = "Prenotazione"
    override val headerActionView = "Vedi"
    override val headerActionReply = "Rispondi"
    override val headerActionUnfollow = "Smetti di seguire"
    override val headerActionFollowBack = "Segui anche tu"
    override val headerActionAccept = "Accetta"
    override val headerActionDecline = "Rifiuta"
    override val headerConfirmTitle = "Sei sicuro?"
    override val headerSignOutConfirmMessage = "Uscirai da Arena su questo dispositivo. I tuoi dati restano al sicuro."
    override val headerSignOutConfirmLabel = "Esci"
    override val headerDeleteConfirmMessage = "L'eliminazione del profilo è permanente. Tutti i crediti, i momenti e le statistiche saranno cancellati."
    override val headerDeleteConfirmLabel = "Conferma eliminazione"
    override val headerDeleteProfileFailed = "Impossibile eliminare il profilo. Riprova."
    override val headerUploading = "Caricamento..."
    override val headerVisualStyle = "Stile visivo"
    override val headerLightTheme = "Tema chiaro"
    override val headerSyncWithSportType = "Sincronizza con lo sport"
    override val headerManageSubscription = "Gestisci abbonamento"
    override val headerCurrentPlan = "Piano attuale:"
    override val headerPlanFree = "Gratuito"
    override val headerPlanUpgrade = "Aggiorna"
    override val headerSignOut = "Esci"
    override val headerSigningOut = "Uscita in corso..."
    override val headerDeleteProfile = "Elimina profilo"
    override val headerRequestNoLongerAvailable = "Questa richiesta non è più disponibile."
    override val headerRequestProcessFailed = "Impossibile elaborare la richiesta. Riprova."
    override val headerSelectClub = "Seleziona club"
    override val headerAddClub = "Aggiungi club"
    override val headerSwitchToPlayer = "Passa a giocatore"
    override val headerLogout = "Esci"
    override val headerLoggingOut = "Uscita in corso..."
    override val headerSigningIn = "Accesso in corso..."

    // home
    override val homeHeroBrand = "Arena Pro Play"
    override val homeHeroUnites = "unisce"
    override val homeHeroAthletes = "atleti"
    override val homeHeroAndTeams = "e squadre"
    override val homeHeroWorldwideFor = "in tutto il mondo per"
    override val homeSectionCreateEventsTitle = "Crea eventi"
    override val homeSectionCreateEventsHighlight = "eventi"
    override val homeSectionCreateEventsSubtitle1 = "Scegli lo sport, imposta l'orario"
    override val homeSectionCreateEventsSubtitle2 = "e aggiungi il luogo della partita."
    override val homeSectionClubsTitle = "Esplora i migliori club"
    override val homeSectionClubsHighlight = "club"
    override val homeSectionTeammatesTitle = "Trova i compagni perfetti"
    override val homeSectionTeammatesHighlight = "compagni"
    override val homeSectionMomentsTitle = "Condividi momenti, connettiti con gli amici"
    override val homeSectionMomentsHighlight = "amici"
    override val homeSectionStatsTitle = "Monitora le statistiche, segui i progressi e personalizza la card"
    override val homeSectionStatsHighlight = "progressi"
    override val homeAltEventsScreen = "Schermata eventi"
    override val homeAltCreateEventScreen = "Schermata di creazione evento"
    override val homeAltCreateEventModal = "Finestra di creazione evento"
    override val homeAltEventDetailScreen = "Schermata di dettaglio evento"
    override val homeAltClubsScreen = "Schermata dei club"
    override val homeAltClubGallery = "Galleria del club"
    override val homeAltClubDetail = "Dettagli del club"
    override val homeAltClubAmenities = "Servizi del club"
    override val homeAltClubMap = "Mappa della posizione del club"
    override val homeAltDiscoverPeople = "Scopri persone"
    override val homeAltPlayerDiscoveryCard = "Card di scoperta giocatori"
    override val homeAltMatchedInterests = "Interessi in comune"
    override val homeAltMatchedInterestsModal = "Finestra degli interessi in comune"
    override val homeAltItsAMatch = "È un match"
    override val homeAltFeedScreen = "Schermata feed"
    override val homeAltFeedPost = "Post del feed"
    override val homeAltGameMomentsPost = "Post dei momenti di gioco"
    override val homeAltChatScreen = "Schermata chat"
    override val homeAltProfileOverview = "Panoramica profilo"
    override val homeAltProfileDashboard = "Dashboard profilo"
    override val homeAltPlayerStatsRadar = "Radar delle statistiche del giocatore"
    override val homeAltPlayerStatsCard = "Card delle statistiche del giocatore"
    override val homeAltRatePerformance = "Valuta la prestazione"
    override val homeAltRatePerformanceModal = "Finestra di valutazione della prestazione"
    override val homeItsYourMatch = "È il tuo match!"
    override val homeLabelClubDetails = "Dettagli del club"
    override val homeLabelGameMoments = "Momenti di gioco"
    override val homeLabelPlayerStats = "Statistiche giocatore"
    override val homeLabelRatePerformance = "Valuta la prestazione"
    override val homeFooterTagline = "La tua community sportiva globale"
    override val homeFooterBlurb = "Trova persone vicino a te per giocare a calcio, tennis, basket, padel o pallavolo: unisciti a partite improvvisate ed eventi sportivi locali, o creane uno tuo su Arena."
    override val homeFooterAbout = "Chi siamo"
    override val homeFooterTerms = "Termini di servizio"
    override val homeFooterPrivacy = "Informativa sulla privacy"
    override val homeFooterPricing = "Prezzi"
    override val homeFooterRefund = "Politica di rimborso"
    override val homeFooterSupports = "Assistenza"
    override val homeFooterCopyright = "© 2026 Arena Pro Play"
    override val homeStoreAppleEyebrow = "SCARICA SU"
    override val homeStoreAppleName = "Apple Store"
    override val homeStoreGoogleEyebrow = "DISPONIBILE SU"
    override val homeStoreGoogleName = "Google Play"
    override fun homeStoreGoogleComingSoon(days: Int) =
        "L'app sarà disponibile su Google Play tra $days ${if (days == 1) "giorno" else "giorni"}"

    override val homeStoryHeroTitle = "Trova persone con cui **fare sport**"
    override val homeStoryHeroSub = "Partite vere vicino a te · Unisciti in due tap"
    override val homeStoryJoinFree = "Unisciti gratis"
    override val homeStoryEventsTitle = "Unisciti a partite **vicino a te**"
    override val homeStoryEventsSub = "Calcio, basket, tennis, volley, padel e altro"
    override val homeStoryMatchTitle = "Fai match con i **giocatori**"
    override val homeStoryMatchSub = "Trova compagni del tuo livello"
    override val homeStoryClubsTitle = "Prenota campi **veri**"
    override val homeStoryClubsSub = "Oltre 1200 club verificati in tutta Europa"
    override val homeStoryMomentsTitle = "Condividi il **gioco**"
    override val homeStoryMomentsSub = "Pubblica i momenti, chatta e resta in contatto"
    override val homeStoryStatsTitle = "Crea la tua carta **giocatore**"
    override val homeStoryStatsSub = "Statistiche, valutazioni e una carta che cresce con te"
    override val homeStoryReadyTitle = "Pronto a **giocare**?"
    override val homeStoryReadySub = "Gratis · iOS e Android"

    // dashboard
    override val dashboardTabAnalytics = "Analisi"
    override val dashboardTabSchedule = "Calendario"
    override val dashboardRatingTitle = "Rating"
    override val dashboardReviews = "recensioni"
    override val dashboardAvgDuration = "Durata media"
    override val dashboardTotalRevenue = "Ricavi totali"
    override val dashboardTotalBookings = "Prenotazioni totali"
    override val dashboardArenaSchedule = "Calendario Arena"
    override val dashboardThisWeek = "Questa settimana"
    override val dashboardAddEvent = "Aggiungi evento"
    override val dashboardTimeHeader = "Orario"
    override val dashboardCustomerFallback = "Cliente"
    override val dashboardRevenueTitle = "Ricavi"
    override val dashboardBookingsTitle = "Prenotazioni"
    override val dashboardBookingStatusTitle = "Stato prenotazioni"
    override val dashboardBookingHeatmapTitle = "Mappa termica prenotazioni"
    override val dashboardDonutTotal = "Totale"
    override val dashboardBookingsTooltipPrefix = "Prenotazioni "
    override val dashboardStatusConfirmed = "Confermate"
    override val dashboardStatusCompleted = "Completate"
    override val dashboardStatusPending = "In attesa"
    override val dashboardStatusUnpaid = "Non pagate"
    override val dashboardStatusDeclined = "Rifiutate"
    override val dashboardNoData = "Nessun dato"
    override val dashboardDayMon = "Lun"
    override val dashboardDayTue = "Mar"
    override val dashboardDayWed = "Mer"
    override val dashboardDayThu = "Gio"
    override val dashboardDayFri = "Ven"
    override val dashboardDaySat = "Sab"
    override val dashboardDaySun = "Dom"
    override fun dashboardHourLabel(hour: Int) = "${hour}h"
    override fun dashboardHeatmapTooltip(day: String, fromHour: Int, toHour: Int, count: Int) = "$day $fromHour:00–$toHour:00 · $count prenotazioni"

    // arena
    override val arenaActionViewResults = "Vedi risultati"
    override val arenaActionWatchLive = "Guarda live"
    override val arenaActionJoinNow = "Partecipa ora"
    override val arenaStatusLive = "Live"
    override val arenaStatusNew = "Nuovo"
    override val arenaStatusCompleted = "Concluso"
    override val arenaStatusCanceled = "Annullato"
    override fun arenaMembersJoinedTotal(joined: Int, total: Int) = "$joined / $total membri"
    override fun arenaMembersCount(count: Int) = "$count membri"
    override fun clubDistanceKm(km: String) = "$km km"
    override fun clubKmAway(km: String) = "a $km km"
    override val pageAmenities = "Servizi"
    override val clubOpenLabel = "Aperto"
    override val clubClosed = "Chiuso"
    override fun clubUntilTime(time: String) = "fino alle $time"
    override fun clubOpensAt(time: String) = "Apre alle $time"
    override val clubTabPhotos = "Foto"
    override val clubNoPhotos = "Ancora nessuna foto"
    override val clubNoAmenities = "Ancora nessun servizio"
    override val clubMapComingSoon = "Mappa in arrivo"
    override fun arenaTeamsCount(count: Int) = "$count squadre"
    override fun arenaFormat(format: String) = "Formato $format"
    override fun arenaFinalScore(score: String) = "Risultato finale $score"
    override fun arenaDuration(duration: String) = "Durata $duration"
    override val arenaLoadingClubs = "Caricamento club..."
    override val arenaLoadingMoreEvents = "Caricamento altri eventi..."
    override val arenaLoadingMoreClubs = "Caricamento altri club..."
    override val arenaLocationLabel = "Posizione: "
    override val arenaAllCities = "Tutte le città"
    override val arenaCommunityAll = "Tutte"
    override val arenaCommunityUnnamed = "Senza nome"
    override val arenaTabClubs = "Club"
    override val arenaTabEvents = "Eventi"
    override val arenaEmptyTitle = "Ancora nessun evento in programma"
    override val arenaEmptySubtitle = "Crea un evento per la chat della partita e il tracciamento in tempo reale."
    override val arenaAddEvent = "Aggiungi evento"
    override val arenaNoClubsTitle = "Ancora nessun club"
    override val arenaNoClubsSubtitle = "I club appariranno qui"

    // people
    override val peopleErrorLoad = "Impossibile caricare le persone"
    override val peopleCaughtUpTitle = "Hai visto tutti"
    override val peopleCaughtUpSubtitle = "Torna più tardi per altri giocatori."
    override val peopleRefresh = "Aggiorna"
    override val peopleBadgeLike = "LIKE"
    override val peopleBadgeNope = "NOPE"
    override fun peopleNameAge(name: String, age: Int) = "$name, $age"

    // feed
    override val feedEmptyTitle = "Il tuo feed è vuoto"
    override val feedEmptySubtitle = "Segui i giocatori per vedere qui i loro post e le loro storie."
    override val feedNoCommentsTitle = "Ancora nessun commento"
    override val feedNoCommentsSubtitle = "Sii il primo a commentare."
    override val feedMessagePlaceholder = "Scrivi un messaggio..."
    override val feedLikeZero = "Mi piace"
    override val feedLikeOne = "1 Mi piace"
    override fun feedLikeMany(count: Int) = "$count Mi piace"

    // auth
    override val authWelcomeTitle = "Benvenuto nell'Arena!"
    override val authWelcomeSubtitle = "Accedi con Google o Apple per creare il tuo profilo, sbloccare questa pagina e iniziare con noi il tuo percorso sportivo."
    override val authAgreePrefix = "Continuando accetti i nostri"
    override val authTerms = "Termini"
    override val authPrivacy = "Privacy"

    // layout
    override val layoutComingSoon = "In arrivo"
}
